import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setCashedPin } from 'store/user/actions.ts';
import {
    selectActiveUserProfile,
    selectCashedPins,
} from 'store/user/selectors.ts';

import { EventParentalControlRating } from 'services/data-manager/types.ts';

function useUpdateCachedPins() {
    const dispatch = useDispatch();

    const cashedPins = useSelector(selectCashedPins);
    const selectedProfileId = useSelector(selectActiveUserProfile);

    return useCallback(() => {
        const storedParentalRatings =
            cashedPins && selectedProfileId && cashedPins[selectedProfileId]
                ? Object.keys(cashedPins[selectedProfileId])
                : [];
        const storedPinTimestamp =
            cashedPins && selectedProfileId
                ? cashedPins?.[selectedProfileId]?.[
                      storedParentalRatings[
                          storedParentalRatings.length - 1
                      ] as unknown as EventParentalControlRating
                  ]
                : 0;

        if (
            cashedPins &&
            selectedProfileId &&
            Date.now() - (storedPinTimestamp || 0) < 86400000
        ) {
            (
                Object.keys(
                    cashedPins[selectedProfileId],
                ) as unknown as EventParentalControlRating[]
            ).forEach((cashedPin) =>
                dispatch(
                    setCashedPin(selectedProfileId, cashedPin, Date.now()),
                ),
            );
        }
    }, [cashedPins, dispatch, selectedProfileId]);
}

export default useUpdateCachedPins;
